import React from 'react';

const colors = [
  '#7c3aed',
  '#4f776d',
  '#8b5cf6',
  '#c4b5fd',
  '#8eb6aa'
];

const particles = Array.from({ length: 30 }, (_, index) => {
  const angle = (index / 30) * Math.PI * 2;
  const distance = 105 + (index % 6) * 19;

  return {
    id: index,
    color: colors[index % colors.length],
    delay: `${(index % 5) * 0.025}s`,
    fall: `${115 + (index % 7) * 15}px`,
    lift: `${-95 - (index % 6) * 14}px`,
    rotation: `${180 + (index % 5) * 72}deg`,
    x: `${Math.cos(angle) * distance}px`
  };
});

function ConfettiBurst() {
  return (
    <div aria-hidden="true" className="confetti-burst">
      {particles.map((particle) => (
        <span
          className={`confetti-particle shape-${particle.id % 3}`}
          key={particle.id}
          style={{
            '--confetti-color': particle.color,
            '--confetti-delay': particle.delay,
            '--confetti-fall': particle.fall,
            '--confetti-lift': particle.lift,
            '--confetti-rotation': particle.rotation,
            '--confetti-x': particle.x
          }}
        />
      ))}
    </div>
  );
}

export default ConfettiBurst;